// libraries imports
import { combineReducers } from 'redux';

// files imports
import snackbarReducer from './slices/snackbar';
import menuReducer from './slices/menu';
import login from './app/authentication/login/reducers';
import forgotPassword from './app/authentication/forgot-password/reducers';
import resetPassword from './app/authentication/reset-password/reducers';
import enableAccount from './app/authentication/enable-account/reducers';
import changePassword from './app/authentication/change-password/reducers';
import users from './app/user-management/reducers';
import formConfiguration from './app/form-management/form-congifuration/reducers';
import regions from './app/form-management/region-configuration/reducers';
import customers from './app/customer-management/reducers';
import farmRecords from './app/farm-management/farm-records/reducers';
import formulae from './app/report-management/reports/reducers';
import reportGeneration from './app/report-management/report-generations/reducers';
import labRecords from './app/lab-management/lab-records/reducers';
import dashboard from './app/dashboard/reducers';
import appVersions from './app/app-management/app-version/reducers';
import downloadAPK from './app/download-APK/reducers';
import states from './app/form-management/state-configuration/reducers';
import districts from './app/form-management/district-configuration/reducers';
import anticoccidals from './app/form-management/anticoccidal-configuration/reducers';

// ==============================|| COMBINE REDUCER ||============================== //

const reducer = combineReducers({
    snackbar: snackbarReducer,
    menu: menuReducer,
    login: login,
    forgotPassword: forgotPassword,
    resetPassword: resetPassword,
    changePassword: changePassword,
    enableAccount: enableAccount,
    users: users,
    formConfiguration: formConfiguration,
    regions: regions,
    states: states,
    districts: districts,
    anticoccidals: anticoccidals,
    customers: customers,
    farmRecords: farmRecords,
    formulae: formulae,
    reportGeneration: reportGeneration,
    labRecords: labRecords,
    appVersions: appVersions,
    dashboard: dashboard,
    downloadAPK: downloadAPK,
});

export default reducer;
